module.exports = __webpack_public_path__ + "static/media/candee-yankles.ca2ccc29.png";